import { Navbar as BootstrapNavbar, Nav, NavDropdown, Container, Offcanvas } from 'react-bootstrap';
import logo from '../../../assets/images/Leaderly_TM.png';
import bellnotify from '../../../assets/images/notification_bell.png';
import sidelogo from '../../../assets/images/TradeMark_Logo.png';
import profilelogo from '../../../assets/images/kanika.png';
import './clientHeader.css';
import { decodeJWT } from '../../../services/candidateService';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import LogoutPopup from '../logout/logout';
import Notification from '../../notification/notification';
import fallbackProfileLogo from '../../content-panes/admin-candidate/candiate-info-nav/img/avatar.png';
import ClientUserService from '../../../services/client-services/clientUserService';
import { CandidateService } from '../../../services/candidateService';
import { useUser } from '../../clients/userContext/userContext';

const ClientHeader = (props) => {
  const decoded = decodeJWT(window.localStorage.getItem('authToken'));
  const username = _.get(decoded, 'username', '');
  const [showSidebar, setShowSidebar] = useState(false);
  const [activeLink, setActiveLink] = useState('client-dashboard');
  const [showResources, setShowResources] = useState(false);
  const [isLogoutPopupVisible, setIsLogoutPopupVisible] = useState(false);
  const [userData, setUserData] = useState({});
  const [renderKey, setRenderKey] = useState(0);
  const { user } = useUser();
  const [showNotif, setShowNotif] = useState(false);
  const role = decoded.roles;
  const isClientUser = role === 'CLIENT_USER';

  useEffect(() => {
    async function fetchUserDetails() {
      if (!username) return;
      try {
        const response = await ClientUserService.getClientDetails(username);
        if (response?.data?.users?.length > 0) {
          const user = response.data.users[0];
          setUserData({
            name: user?.name || "Unknown User",
            designation: user?.designation || "No Designation",
            dpPath: user?.dpPath || fallbackProfileLogo,
          });
        }
      } catch (error) {
        console.error("Error fetching user details:", error);
      }
    }
    fetchUserDetails();
  }, [username]);

  const logout = async () => {
    await CandidateService.logout();
    sessionStorage.removeItem('searchFilters');
    sessionStorage.removeItem('filteredResults');
    sessionStorage.removeItem('currentPage');
    sessionStorage.removeItem('totalPages');
    sessionStorage.removeItem('viewMode');
    sessionStorage.removeItem('showResultsSection');
    sessionStorage.removeItem('searchFormData');
    localStorage.removeItem('authToken');
    localStorage.clear();
    sessionStorage.clear();
    window.location.reload();
  };


  const openLogoutPopup = () => setIsLogoutPopupVisible(true);
  const closeLogoutPopup = () => setIsLogoutPopupVisible(false);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1274 && showSidebar) {
        setShowSidebar(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [showSidebar]);

  const location = useLocation();

  useEffect(() => {
    setRenderKey((prevKey) => prevKey + 1);

    switch (location.pathname) {
      case '/navbar-faq':
      case '/resources-blog':
      case '/policy':
      case '/pricing-prelogin':
      case '/contact-us':
      case '/about-us':
        setActiveLink('resources');
        setShowResources(true);
        break;
      case '/blogdetails':
      case '/contact-sales':
        setActiveLink('resources');
        setShowResources(true);
        break;
      case '/client/search-candidate':
      case '/client/candidate-information':
      case '/client/candidate-search-result':
        setActiveLink('search-candidate');
        setShowResources(false);
        break;
      case "/client/job-postings":
        setActiveLink("job-postings");
        setShowResources(false);
        break;
      case '/client/candidate-reports':
        setActiveLink('/client/candidate-reports');
        setShowResources(false);
        break;
      case '/client/users':
        setActiveLink('/client/users');
        setShowResources(false);
        break;
      case '/client/dashboard':
        setActiveLink('client/dashboard');
        setShowResources(false);
        break;
      case '/client/client-user-profile':
        setActiveLink('client-profile');
        setShowResources(false);
        break;
      default:
        setActiveLink('client/dashboard');
        setShowResources(false);
        break;
    }
  }, [location.pathname]);

  const handleLinkClick = (link) => {
    setActiveLink(link);
    setShowResources(link === 'resources');
    setShowSidebar(false);
  };
  const handleSidebarClose = () => {
    setShowSidebar(false);
    const navbarCollapse = document.getElementById("navbar-nav");
    if (navbarCollapse) {
      navbarCollapse.classList.remove("show");
    }
  };

  const handleSidebarShow = () => setShowSidebar(true);
  const toggleResources = () => {
    setActiveLink('resources');
    setShowResources(!showResources);
  };


  return (
    <div key={renderKey}>
      <BootstrapNavbar expand="lg" className="client-navbar">
        <Container className="d-flex justify-content-between align-items-center" style={{ maxWidth: '1300px' }}>
          <div className="d-flex align-items-center">
            <BootstrapNavbar.Toggle aria-controls="navbar-nav" onClick={handleSidebarShow} />
            <BootstrapNavbar.Brand href="#">
              <img src={logo} alt="Logo" className="client-navbar-logo" />
            </BootstrapNavbar.Brand>
          </div>
          <div className="d-flex align-items-center">
            <BootstrapNavbar.Collapse id="navbar-nav" className="justify-content-end">
              <Nav>
                <Nav.Link
                  as={Link}
                  to="/client/dashboard"
                  className={`client-nav-link ${activeLink === 'client/dashboard' ? 'client-active-link' : ''}`}
                  onClick={(e) => {
                    handleLinkClick('client/dashboard');
                    sessionStorage.clear();
                  }}
                >
                  Dashboard
                </Nav.Link>

                <Nav.Link
                  as={Link}
                  to="/client/search-candidate"
                  className={`client-nav-link ${activeLink === 'search-candidate' ? 'client-active-link' : ''}`}
                  onClick={(e) => {
                    handleLinkClick('search-candidate');
                    sessionStorage.clear();
                  }}
                >
                  My Candidates
                </Nav.Link>

                <Nav.Link
                  as={Link}
                  to="/client/job-postings"
                  className={`client-nav-link ${activeLink === "job-postings" ? "client-active-link" : ""
                    }`}
                  onClick={() => {
                    handleLinkClick("job-postings");
                    sessionStorage.clear();
                  }}
                >
                  Job Postings
                </Nav.Link>
                {/* <Nav.Link
                  as={Link}
                  to="/client/candidate-reports"
                  className={`client-nav-link ${activeLink === '/client/candidate-reports' ? 'client-active-link' : ''}`}
                  onClick={(e) => {
                    handleLinkClick('/client/candidate-reports');
                    sessionStorage.clear();
                  }}
                >
                  Reports
                </Nav.Link> */}
                <NavDropdown
                  title={
                    <span className={`client-nav-link ${activeLink === 'resources' ? 'client-active-link' : ''}`}>
                      Resources
                    </span>
                  }
                  className="client-nav-link"
                  onClick={() => {
                    handleLinkClick('resources');
                    sessionStorage.clear();
                  }
                  }
                >
                  <NavDropdown.Item
                    as={Link}
                    to="/about-us"
                    className={`client-dropdown-link ${location.pathname === '/about-us' ? 'client-active-dropdown-link' : ''
                      }`}
                  >
                    About Us
                  </NavDropdown.Item>
                  {/* <NavDropdown.Item
                    as={Link}
                    to="/policy"
                    className={`client-dropdown-link ${location.pathname === '/policy' ? 'client-active-dropdown-link' : ''
                      }`}
                  >
                    Policy
                  </NavDropdown.Item> */}
                  <NavDropdown.Item
                    as={Link}
                    to="/resources-blog"
                    className={`client-dropdown-link ${location.pathname === '/resources-blog' || location.pathname === '/blogdetails' ? 'client-active-dropdown-link' : ''

                      }`}
                  >
                    Blog
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    as={Link}
                    to="/navbar-faq"
                    className={`client-dropdown-link ${location.pathname === '/navbar-faq' ? 'client-active-dropdown-link' : ''
                      }`}
                  >
                    FAQ
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    as={Link}
                    to="/pricing-prelogin"
                    className={`client-dropdown-link ${location.pathname === '/pricing-prelogin' || location.pathname === '/contact-sales' ? 'client-active-dropdown-link' : ''
                      }`}
                  >
                    Pricing
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    as={Link}
                    to="/contact-us"
                    className={`client-dropdown-link ${location.pathname === '/contact-us' ? 'client-active-dropdown-link' : ''
                      }`}
                  >
                    Contact Us
                  </NavDropdown.Item>
                </NavDropdown>
              </Nav>
            </BootstrapNavbar.Collapse>
            <div className="client-nav-item">
              {/* <img
                src={bellnotify}
                alt="bellnotify"
                className="bell-notify"
                onClick={() => setShowNotif(!showNotif)}
              />
              {showNotif && <Notification />}  */}
              {/* <img
                src={bellnotify}
                alt="bellnotify"
                className="bell-notify"
                onClick={() => setShowNotif(!showNotif)}
              />
              {showNotif && <Notification setShowNotif={setShowNotif} />} */}

              <div className="profile-container">

                <img
                  src={user?.imageBlobUrl || fallbackProfileLogo}
                  className="profile-logo"
                  onError={(e) => (e.target.src = fallbackProfileLogo)}
                /></div>

              <div className="client-nav-info">
                <div className="client-nav-name">
                  <NavDropdown
                    id="signite-nav-dropdown1"
                    title={
                      <span className="client-nav-text">{user?.name}</span>
                    }
                    style={{ padding: 0 }}
                  >
                    <NavDropdown.Item href="/client/client-user-profile"
                      className={`client-dropdown-item ${location.pathname === '/client/client-user-profile' ? 'active' : ''}`}
                    >
                      Profile
                    </NavDropdown.Item>
                    {!isClientUser && (
                      <NavDropdown.Item
                        href="/client/users"
                        className={`client-dropdown-item ${location.pathname === '/client/users' ? 'active' : ''}`}
                      >
                        Users
                      </NavDropdown.Item>
                    )}

                    <NavDropdown.Item
                      as={Link}
                      to="/client/password-reset"
                      className={`client-dropdown-item ${location.pathname === '/client/password-reset' ? 'active' : ''}`}
                    >
                      Reset Password
                    </NavDropdown.Item>

                    <NavDropdown.Item
                      href="#"
                      onClick={openLogoutPopup}
                      className="client-dropdown-item"
                    >

                      Logout
                    </NavDropdown.Item>
                  </NavDropdown>

                </div>
                <span className="client-nav-subtext">{user?.designation}</span>
              </div>
            </div>
          </div>
        </Container>
      </BootstrapNavbar>
      <LogoutPopup
        isVisible={isLogoutPopupVisible}
        onClose={closeLogoutPopup}
        onConfirm={logout}
      />
      <Offcanvas show={showSidebar} onHide={handleSidebarClose} placement="start" className="client-sidebar">
        <Offcanvas.Header closeButton>
          <img src={sidelogo} alt="Logo" className="client-sidebar-logo" />
        </Offcanvas.Header>
        <hr className="client-sidebar-divider" />
        <Offcanvas.Body className="d-flex flex-column">
          <Nav className="flex-column align-items-start w-100">
            <div className="client-sidebar-link-container">
              <Nav.Link
                href="/client/dashboard"
                className={`client-sidebar-link ${activeLink === 'client/dashboard' ? 'client-active-sidebar-link' : ''
                  }`}
                onClick={() => {
                  handleLinkClick('client/dashboard');
                  sessionStorage.clear();
                }}
              >
                Dashboard
              </Nav.Link>
            </div>
            <div className="client-sidebar-link-container">
              <Nav.Link
                href="/client/search-candidate"
                className={`client-sidebar-link ${activeLink === 'search-candidate' ? 'client-active-sidebar-link' : ''}`}
                onClick={() => {
                  handleLinkClick('search-candidate');
                  sessionStorage.clear();
                }
                }
              >
                My Candidates
              </Nav.Link>
            </div>
            <div className="client-sidebar-link-container">
              <Nav.Link
                href="/client/job-postings"
                className={`client-sidebar-link ${activeLink === "job-postings" ? "client-active-sidebar-link" : ""
                  }`}
                onClick={() => {
                  handleLinkClick("job-postings");
                  sessionStorage.clear();
                }}
              >
                Job Postings
              </Nav.Link>
            </div>
            {/* <div className="client-sidebar-link-container">
              <Nav.Link
                href="/client/candidate-reports"
                className={`client-sidebar-link ${activeLink === '/client/candidate-reports' ? 'client-active-sidebar-link' : ''}`}
                onClick={() => handleLinkClick('/client/candidate-reports')}
              >
                Reports
              </Nav.Link>
            </div> */}
            <div
              className={`client-sidebar-link resources-link ${activeLink === 'resources' ? 'client-active-sidebar-link' : ''
                }`}
              onClick={() => {
                sessionStorage.clear();
                toggleResources();
              }}
            >
              Resources <span className="resources-client-arrow">{showResources ? '^' : '>'}</span>
            </div>
            {showResources && (
              <div className="client-resources-dropdown">
                <Nav.Link
                  as={Link}
                  to="/about-us"
                  className={`client-sidebar-link ${location.pathname === '/about-us' ? 'client-active-sidebar-link' : ''
                    }`}
                  onClick={() => handleLinkClick('/about-us')}

                >
                  About Us
                </Nav.Link>
                {/* <Nav.Link
                  as={Link}
                  to="/policy"
                  className={`client-sidebar-link ${location.pathname === '/policy' ? 'client-active-sidebar-link' : ''
                    }`}
                  onClick={() => handleLinkClick('/policy')}

                >
                  Policy
                </Nav.Link> */}
                <Nav.Link
                  as={Link}
                  to="/resources-blog"
                  className={`client-sidebar-link ${location.pathname === '/resources-blog' || location.pathname === '/blogdetails' ? 'client-active-sidebar-link' : ''
                    }`}
                  onClick={() => handleLinkClick('/resources-blog')}

                >
                  Blog
                </Nav.Link>
                <Nav.Link
                  as={Link}
                  to="/navbar-faq"
                  className={`client-sidebar-link ${location.pathname === '/navbar-faq' ? 'client-active-sidebar-link' : ''
                    }`}
                  onClick={() => handleLinkClick('/navbar-faq')}

                >
                  FAQ
                </Nav.Link>
                <Nav.Link
                  as={Link}
                  to="/pricing-prelogin"
                  className={`client-sidebar-link ${location.pathname === '/pricing-prelogin' || location.pathname === 'contact-sales' ? 'client-active-sidebar-link' : ''
                    }`}
                  onClick={() => handleLinkClick('/pricing-prelogin')}

                >
                  Pricing
                </Nav.Link>
                <Nav.Link
                  as={Link}
                  to="/contact-us"
                  className={`client-sidebar-link ${location.pathname === '/contact-us' ? 'client-active-sidebar-link' : ''
                    }`}
                  onClick={() => handleLinkClick('/contact-us')}

                >
                  Contact Us
                </Nav.Link>
              </div>
            )}
          </Nav>
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
};
export default ClientHeader;